function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 1v15.714a3.157 3.157 0 0 0 3.143 3.143H11.3C12.393 21.73 14.4 23 16.714 23 20.176 23 23 20.176 23 16.714h-1.571a4.7 4.7 0 0 1-4.715 4.715A4.7 4.7 0 0 1 12 16.714 4.7 4.7 0 0 1 16.714 12h1.572v3.143l3.928-3.929-3.928-3.928v3.143h-1.572c-.546 0-1.068.092-1.571.22V7.287h1.571V5.714h-1.571V1H1zm1.571 1.571h11v8.73c-.503.3-.97.644-1.375 1.067V12H8.857v1.571H11.3a6.333 6.333 0 0 0-.65 1.572H8.857v1.571h1.572c0 .547.092 1.068.22 1.572H4.144a1.559 1.559 0 0 1-1.572-1.572V2.571zm1.572 3.143v1.572H12V5.714H4.143zm0 3.143v1.572h3.143V8.857H4.143zm4.714 0v1.572H12V8.857H8.857zM4.143 12v1.571h3.143V12H4.143zm0 3.143v1.571h3.143v-1.571H4.143z"
});

var SvgIcRenew = function SvgIcRenew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcRenew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_renew.7bbf84de.svg";
export { ForwardRef as ReactComponent };